import React, { useState } from "react";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import ApplicantReview from "views/admin/components/ApplicantReview";
import OrnamentReview from "views/admin/components/OrnamentReview";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { Grid, withStyles } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import brandTheme from "brandTheme/Theme";
import LenderReview from "views/admin/components/LenderReview";
import PawanTickerReview from "views/admin/components/PawanTickerReview";
import { headerLabel } from "assets/properties/properties";
import FamilyDetailsReview from "views/admin/components/FamilyReview";
import { parseAndSetFlag } from "utils/Utils";
const style = (theme) => ({
  nextButton:{
    boxShadow:'inherit',
    color:brandTheme.white,
    margin:"0 5px 0 0 ",
    letterSpacing:"1px",
    height:"40px",
    backgroundColor:brandTheme.buttonColor,
    '&:hover':{
      backgroundColor:brandTheme.buttonHoverColor, 
      boxShadow:'inherit',
    }
  },
})


const Review = ({
  setNext,
  setBack,
  props,
  loanApplicationId,
  loanApplicationNumber,
  editable,
  classes,
  subStatus,
  loanAccountNumber,
  featureFlags
}) => {
  const params = useParams();
  const [record, setRecord] = useState({});
  const [callInProgress, setCallInProgress] = useState(false);
    const showFamilyDetails = parseAndSetFlag(featureFlags?.creditAssessment);
    const showAttachement = parseAndSetFlag(featureFlags?.enableAttachementOnCreditAdditionDetails);
  const handlecreateuserSubmit = async () => {
    setNext();
  };

  // cancel button function
  const handlecanceluser = () => {
    setBack();
  };
  return (
      <Grid container>
      <Grid item xs={12} sm={12} md={12}>
          <SubHeader
             label={headerLabel?.review}
             subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
             onlyLabel
          />
      </Grid>
      <GridContainer style={{ margin: "0 auto",textAlign:"left"}}>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <ApplicantReview loanApplicationId={loanApplicationId} editable={editable} classes={classes} subStatus={subStatus} loanAccountNumber={loanAccountNumber}/>
          <hr />
          {(subStatus === "PRE_PLEDGE" || subStatus === "POST_PLEDGE") &&
          <>
          <LenderReview loanApplicationId={loanApplicationId} classes={classes}/>
          <PawanTickerReview loanApplicationId={loanApplicationId} classes={classes}/>
          </>}
          <FamilyDetailsReview loanApplicationId={loanApplicationId} classes={classes} showAttachement={showAttachement} featureFlags={featureFlags}/>
          {subStatus !== "PRE_PLEDGE" && <OrnamentReview loanApplicationId={loanApplicationId} classes={classes}/>}

          <GridContainer>
            <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: "end" }}
            >
              <Button
                style={{ margin: "5px" }}
                size="small"
                className={classes.nextButton1}
                onClick={() => handlecanceluser()}
              >
                Back
              </Button>
              <Button
                style={{ margin: "5px" }}
                size="small"
                className={classes.nextButton}
                onClick={() => handlecreateuserSubmit()}
              >
                Next
              </Button>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>

       {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
        </Grid>
  
  );
};

Review.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  loanApplicationNumber: PropTypes.object,
};

export default withStyles(style)(Review);